import { render } from "./promotionHome.vue?vue&type=template&id=f5756ad0&scoped=true"
import script from "./promotionHome.vue?vue&type=script&lang=js"
export * from "./promotionHome.vue?vue&type=script&lang=js"

import "./promotionHome.vue?vue&type=style&index=0&id=f5756ad0&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5756ad0"]])

export default __exports__